<template>
   <div class="card switch-plan">
        <h6>Your New Tariff</h6>

        <div class="row">
          <div class="col-xs-5 _margin-bottom-20">
              <supplier-logo :id="plan.supplierId"></supplier-logo>
          </div>

          <div class="col-xs-7">
              <p class="_margin-top-0 _margin-bottom-10">{{ plan.tariffName }}</p>
          </div>

          <div class="col-xs-12" v-if="!plan.gasCost">
            <h6 class="_margin-bottom-0">{{ plan.fuelTitle }} Cost</h6>
            <div class="row">
              <div class="col-xs-6">
                <small>Annual</small>
                <h5 class="_margin-bottom-0">{{ plan.cost | currency(2) }}</h5>
              </div>

              <div class="col-xs-6">
                <small>Monthly</small>
                <h5 class="_margin-bottom-0">{{ roundUp(divideBy(plan.cost, 12)) | currency(2) }}</h5>
              </div>
            </div>
          </div>

          <div class="col-xs-12" v-if="plan.gasCost">
              <div class="row">
                <div class="col-xs-12 _margin-bottom-20">
                    <h6 class="_margin-bottom-0">Electricity Cost</h6>
                    <div class="row">
                      <div class="col-xs-6">
                          <small>Annual</small>
                          <h5 class="_margin-bottom-0">{{ plan.cost | currency(2) }}</h5>
                      </div>

                      <div class="col-xs-6">
                          <small>Monthly</small>
                          <h5 class="_margin-bottom-0">{{ divideBy(plan.cost, 12) | currency(2) }}</h5>
                      </div>
                    </div>
                </div>

                <div class="col-xs-12">
                    <h6 class="_margin-bottom-0">Gas Cost</h6>
                    <div class="row">
                      <div class="col-xs-6">
                          <small>Annual</small>
                          <h5 class="_margin-bottom-0">{{ plan.gasCost | currency(2) }}</h5>
                      </div>

                      <div class="col-xs-6">
                          <small>Monthly</small>
                          <h5 class="_margin-bottom-0">{{ divideBy(plan.gasCost, 12) | currency(2) }}</h5>
                      </div>
                    </div>
                </div>
              </div>

              <hr />

              <div class="row">
                <div class="col-xs-12">
                  <h6 class="_margin-bottom-0">Total Cost</h6>
                  <div class="row">
                    <div class="col-xs-6">
                        <small>Annual</small>
                        <h4 class="_margin-top-0 _margin-bottom-0">{{ (plan.cost + plan.gasCost) | currency(2) }}</h4>
                    </div>

                    <div class="col-xs-6">
                        <small>Monthly</small>
                        <h4 class="_margin-top-0 _margin-bottom-0">{{ roundUp((divideBy(plan.cost, 12) + divideBy(plan.gasCost, 12))) | currency(2) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
import SupplierLogo from '../../../../base/components/supplier-logo/SupplierLogo';

export default {
  name: 'SwitchPlan',
  data () {
    return {
      moreTariffDetails: false
    };
  },
  props: {
    plan: Object
  },
  methods: {
    divideBy (number, by) {
      if (!number) {
        return number;
      }

      return number / by;
    },
    roundUp (number) {
      return Math.ceil(number);
    }
  },
  components: {
    SupplierLogo
  }
};
</script>

<style lang="scss"></style>
